import React from 'react';
import { Space, Typography, Alert } from 'antd';
import { ExclamationCircleOutlined, CheckCircleOutlined, InfoCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useTheme } from '../../contexts/ThemeContext';
import Modal from './Modal';

const { Title, Text } = Typography;

const AlertModal = ({
  open,
  onClose,
  title,
  message,
  description,
  type = 'warning', // success, info, warning, error
  showIcon = true,
  actions,
  closeText = 'Entendido',
  width = 420,
  ...props
}) => {
  const { theme } = useTheme();

  // Configurações baseadas no tipo
  const getTypeConfig = () => {
    const configs = {
      success: {
        icon: <CheckCircleOutlined style={{ fontSize: '24px', color: '#52c41a' }} />,
        color: '#52c41a',
        defaultTitle: 'Sucesso'
      },
      info: {
        icon: <InfoCircleOutlined style={{ fontSize: '24px', color: '#1890ff' }} />,
        color: '#1890ff',
        defaultTitle: 'Informação'
      },
      warning: {
        icon: <ExclamationCircleOutlined style={{ fontSize: '24px', color: '#faad14' }} />,
        color: '#faad14',
        defaultTitle: 'Atenção'
      },
      error: {
        icon: <CloseCircleOutlined style={{ fontSize: '24px', color: '#ff4d4f' }} />,
        color: '#ff4d4f',
        defaultTitle: 'Erro'
      }
    };

    return configs[type] || configs.warning;
  };

  const typeConfig = getTypeConfig();

  return (
    <Modal
      title={showIcon ? (
        <Space>
          {typeConfig.icon}
          <Title level={4} style={{ margin: 0, color: theme.textSecondary }}>
            {title || typeConfig.defaultTitle}
          </Title>
        </Space>
      ) : (
        <Title level={4} style={{ margin: 0, color: theme.textSecondary }}>
          {title || typeConfig.defaultTitle}
        </Title>
      )}
      open={open}
      onCancel={onClose}
      variant="alert"
      width={width}
      showOkButton={false}
      showCancelButton={!actions}
      cancelText={closeText}
      footer={actions}
      {...props}
    >
      <div style={{ padding: '8px 0' }}>
        {/* Alert do Ant Design para consistência visual */}
        <Alert
          message={message}
          description={description}
          type={type}
          showIcon={showIcon}
          style={{
            border: 'none',
            backgroundColor: `${typeConfig.color}10`,
            borderRadius: '8px'
          }}
        />
      </div>
    </Modal>
  );
};

export default AlertModal; 